const handleCompleteActionFormActions = {
  confirm: 'Deseja realmente concluir essa ação?',
  title: 'CONCLUIR AÇÃO',
  newStatus: 'Concluido',
  inputError: 'A mensagem de conclusão é necessária'
};

export default handleCompleteActionFormActions;
